export default __webpack_public_path__ + "static/material_01-e3ddfcb88b4d43a15cf1b79c3160da58.png";